(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ljf-product-conversion"] && !Shopify.designMode) return;
  try {
    
  class LjfProductSection {
    constructor(root) {
      this.root = root;
      this.form = root.querySelector('.ljf-form');
      this.variants = JSON.parse(root.querySelector('[data-ljf-variants]').textContent);
      this.bundles = [...root.querySelectorAll('[data-ljf-bundle-input]')];
      this.variantInput = root.querySelector('[data-ljf-variant-id]');
      this.bonusInput = root.querySelector('[data-ljf-bonus]');
      this.addButton = root.querySelector('[data-ljf-add]');
      this.addLabel = root.querySelector('[data-ljf-add-label]');
      this.purchaseOptions = [...root.querySelectorAll('[data-ljf-purchase]')];
      this.sellingPlanInput = root.querySelector('[data-ljf-selling-plan]');
      this.stickyBar = root.querySelector('[data-ljf-sticky-buy]');
      this.stickyButton = root.querySelector('[data-ljf-sticky-add]');
      this.stickySummary = root.querySelector('[data-ljf-sticky-summary]');
      this.addText = this.addLabel.textContent.trim();
      this.soldText = this.addButton.disabled ? this.addText : 'Sold out';
      this.bundles.forEach((control) => control.addEventListener('change', () => this.sync()));
      this.purchaseOptions.forEach((control) => control.addEventListener('change', () => this.syncPurchase()));
      this.stickyButton?.addEventListener('click', () => this.form.requestSubmit(this.addButton));
      if (this.stickyBar) {
        this.addButtonObserver = new IntersectionObserver(([entry]) => {
          this.stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
          this.stickyBar.setAttribute('aria-hidden', entry.isIntersecting ? 'true' : 'false');
        }, { threshold: 0.1 });
        this.addButtonObserver.observe(this.addButton);
      }
      this.sync();
      this.syncPurchase();
    }

    syncPurchase() {
      if (!this.sellingPlanInput) return;

      const subscriptionSelected = this.purchaseOptions.some((control) => control.checked && control.value === 'subscription');
      if (subscriptionSelected && this.bundles.find((control) => control.checked)?.value === '25') {
        const fiftyPack = this.bundles.find((control) => control.value === '50');
        if (fiftyPack) {
          fiftyPack.checked = true;
          this.sync();
        }
      }

      this.sellingPlanInput.disabled = !subscriptionSelected;
      this.root.querySelectorAll('.ljf-purchase-option').forEach((option) => {
        option.classList.toggle('is-selected', option.querySelector('input').checked);
      });
    }

    sync() {
      const pieces = this.bundles.find((control) => control.checked)?.value || '50';
      const matchingVariants = this.variants.filter((item) => item.options.at(-1) === `${pieces}pcs.`);
      const variant = matchingVariants.find((item) => item.available) || matchingVariants[0];

      this.root.querySelectorAll('[data-ljf-bundle]').forEach((card) => {
        card.classList.toggle('is-selected', card.dataset.pieceCount === pieces);
      });
      this.bonusInput.disabled = pieces !== '100';

      if (!variant) {
        this.addButton.disabled = true;
        this.addLabel.textContent = this.soldText;
        return;
      }

      this.variantInput.value = variant.id;
      this.addButton.disabled = !variant.available;
      this.addLabel.textContent = variant.available ? this.addText : this.soldText;
      this.stickyButton.disabled = !variant.available;
      const selectedCard = this.root.querySelector(`[data-ljf-bundle][data-piece-count="${pieces}"]`);
      const selectedTitle = selectedCard?.querySelector('.ljf-bundle__copy strong')?.textContent.trim();
      const selectedPrice = selectedCard?.querySelector('.ljf-bundle__price strong')?.textContent.trim();
      if (this.stickySummary && selectedTitle && selectedPrice) {
        this.stickySummary.textContent = `${selectedTitle} · ${selectedPrice}`;
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }
  }

  document.querySelectorAll('[data-ljf-product-section]').forEach((root) => new LjfProductSection(root));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
